import { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { TRANSACTION_TYPE } from 'consts';
import AuditContext from 'components/common/Audit/AuditContext';
import {
  formatCurrency,
  formatDateMDY,
  getTypeLabel,
} from '../../History/config/DetailsRender/consts';

const GuestScheduledAuditTitle = () => {
  const { item } = useContext(AuditContext);

  const title = getTypeLabel(item?.[TRANSACTION_TYPE] || item?.transactionType);
  const subtitle = (() => {
    const parts = [];

    if (item?.sendOn) {
      parts.push(formatDateMDY(item.sendOn));
    }

    if (item?.amount != null) {
      parts.push(formatCurrency(item.amount));
    }

    return parts.length > 0 ? parts.join(' - ') : null;
  })();
  return (
    <Grid container direction="column">
      <Grid item>
        <Typography color="inherit" variant="h6">
          Audit Details {title ? `- ${title}` : ''}
        </Typography>
      </Grid>
      {subtitle && (
        <Grid item>
          <Typography color="textSecondary" variant="body1">
            {subtitle}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default GuestScheduledAuditTitle;
